import { apiUrl } from "config";
import * as createApi from "lib/createRestApiClient";

const name = "api/admin/figures";

export const getAll = createApi.getAll<FigureView>(apiUrl, name);
export const getOne = createApi.getOne<FigureView>(apiUrl, name);
export const create = createApi.create<Figure>(apiUrl, name);
export const update = createApi.update<Figure>(apiUrl, name);
export const del = createApi.del<Figure>(apiUrl, name);
